import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { fish_image } from "../../constant/urls";
import { useAppContext } from "../../context/state";
import { addCommas, useRequest } from "../../utils";
import moment from "jalali-moment";
//locall

const UserDetails = (props) => {
  //   const data = props.location.query.data;
  //   const [
  //     verify_cart_fish_error,
  //     verify_cart_fish_loading,
  //     verify_cart_fish_data,
  //     verify_cart_fish_function,
  //   ] = useRequest({
  //     method: "post",
  //     url: "/verify_cart_fish",
  //     body: {
  //       payment_id: props.match.params.id,
  //     },
  //     isFunction: true,
  //   });
  let history = useHistory();

  const [
    get_user_details_error,
    get_user_details_loading,
    get_user_details_data,
    get_user_details_function,
  ] = useRequest({
    method: "post",
    url: "/get_user_details",
    body: {
      user_id: props.match.params.id,
    },
  });
  const [
    delete_all_products_error,
    delete_all_products_loading,
    delete_all_products_data,
    delete_all_products_function,
  ] = useRequest({
    method: "post",
    url: "/delete_all_products",
    body: {
      user_id: props.match.params.id,
    },
    isFunction: true,
  });

  console.log(get_user_details_data);

  const data = get_user_details_data?.data;

  return !data ? null : (
    <>
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  {/* <li class="breadcrumb-item active">افزودن محصول جدید</li> */}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <section className="card card-body">
          <div class="content-body">
            {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
            <div style={{ marginBottom: "10px" }}>
              نام کاربر : {data.user_data.name}
            </div>
            {/* <button
              type="button"
              class="btn btn-warning round mr-1 mb-1 btn-sm"
              style={{ width: "fit-content" }}
              onClick={() =>
                delete_all_products_function()
                  .then(() => {
                    utils.showAlert(
                      "حذف همه ی محصولات با موفقیت انجام شد",
                      "success"
                    );
                    get_user_details_function();
                  })
                  .catch(() =>
                    utils.showAlert(
                      "مشکلی در انجام عملیات به وجود آمد",
                      "error"
                    )
                  )
              }
            >
              حذف همه محصولات
            </button> */}

            <h6>تراکنش های کاربر :</h6>
            {data ? (
              data.payment_data ? (
                <Table
                  Thead={() => (
                    <tr>
                      <th className="table--title">شماره</th>
                      <th className="table--title">مبلغ</th>
                      <th className="table--title">نوع پرداخت</th>
                      <th className="table--title">توضیح پرداخت</th>
                      <th className="table--title">وضعیت</th>
                      <th className="table--title">تاریخ ایجاد تراکنش</th>

                      {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                      <th className="table--title">عملیات</th>
                    </tr>
                  )}
                  Tbody={() =>
                    data.payment_data.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{addCommas(item._price) + "تومان"}</td>
                        <td>
                          {item._type === "online" ? "آنلاین" : "کارت به کارت"}
                        </td>
                        <td>
                          {item._des === "initial_payment"
                            ? "پرداخت اولیه"
                            : null}
                          {item._des === "term_support_payment"
                            ? "پرداخت پشتیبانی ترم"
                            : null}
                          {item._des === "term_payment" ? "پرداخت ترم" : null}
                        </td>
                        <td>
                          {item._status === "paid"
                            ? "موفق"
                            : item._status === "waiting"
                            ? "در انتظار تایید"
                            : "ناموفق"}
                        </td>
                        <td style={{ direction: "ltr" }}>
                          {moment(item.creation_date)
                            .locale("fa")
                            .format("YYYY/MM/DD, h:mm:ss a")}
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/dashboard/paymentDetails/" + item._id,
                            }}
                          >
                            <button
                              type="button"
                              class="btn btn-primary round mr-1 mb-1 btn-sm"
                            >
                              جزییات
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))
                  }
                />
              ) : null
            ) : null}
            {/* <button
              onClick={() =>
                history.push(
                  "/dashboard/userDetails/" +
                    props.match.params.id +
                    "/addProductToUser"
                )
              }
              style={{ marginTop: "1rem" }}
              type="button"
              class="btn btn-success mr-1 mb-1 "
            >
              افزودن محصول جدید
            </button> */}
            <h6>سفارشات کاربر :</h6>
            {data ? (
              data.order_data ? (
                <Table
                  Thead={() => (
                    <tr>
                      <th className="table--title">شماره</th>
                      <th className="table--title">کد سفارش</th>
                      <th className="table--title">مبلغ</th>
                      <th className="table--title">عملیات</th>
                    </tr>
                  )}
                  Tbody={() =>
                    data.order_data.map((item, index) => (
                      <tr>
                        <>
                          <td>{index + 1}</td>
                          <td>{item.order_code}</td>
                          <td>{addCommas(item.final_price)} تومان </td>
                          <td>
                            <Link
                              to={{
                                pathname: "/dashboard/orderDetails/" + item._id,
                              }}
                            >
                              <button
                                type="button"
                                class="btn btn-primary round mr-1 mb-1 btn-sm"
                              >
                                جزییات
                              </button>
                            </Link>
                          </td>
                        </>
                      </tr>
                    ))
                  }
                />
              ) : null
            ) : null}
          </div>
          {/* <div class="row" style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "10px" }}></div>
            <div style={{ marginBottom: "10px" }}>
              کد رهگیری : {data._ref_id}
            </div>
            <div style={{ marginBottom: "10px" }}>تصویر فیش واریزی :</div>
            <img
              src={fish_image + data.fish_img.name}
              alt="fish"
              style={{
                width: "100%",
                maxWidth: "30rem",
                objectFit: "cover",
                marginBottom: "10px",
              }}
            />
            <div style={{ marginBottom: "10px" }}>
              وضعیت تراکنش :
              {data._status === "paid"
                ? "پرداخت شده"
                : data._status === "unpaid"
                ? "پرداخت نشده"
                : data._status === "waiting"
                ? "در انتظار تایید"
                : null}
              {data._status === "waiting" ? (
                <button
                  type="button"
                  class="btn btn-success round mr-1 mb-1 btn-sm"
                  style={{ width: "fit-content" }}
                  onClick={() =>
                    verify_cart_fish_function()
                      .then(() => {
                        utils.showAlert("فیش با موفقیت تایید شد", "success");
                        history.push("/dashboard/getPayments/");
                      })
                      .catch(() =>
                        utils.showAlert(
                          "مشکلی در انجام عملیات به وجود آمد",
                          "error"
                        )
                      )
                  }
                >
                  تایید فیش
                </button>
              ) : null}
            </div>
          </div> */}
        </section>
      </div>
      {/* <!-- BEGIN: Content--> */}
    </>
  );
};

export { UserDetails };
